var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('loader-component',{attrs:{"with_text":true,"text":_vm.text,"text_class":"text-white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }